import { render, staticRenderFns } from "./UnreadMessage.vue?vue&type=template&id=5e993926&scoped=true&"
import script from "./UnreadMessage.vue?vue&type=script&lang=js&"
export * from "./UnreadMessage.vue?vue&type=script&lang=js&"
import style0 from "./UnreadMessage.vue?vue&type=style&index=0&id=5e993926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e993926",
  null
  
)

export default component.exports